import { moveWatermark } from '@root/private/js/common/watermark/move-watermark';
import { makeWatermarkDataURL } from '@root/private/js/common/watermark/make-watermark-data-url';
import { Watermark } from '@src/modules/players/shared/interfaces/player-configs.interface';
import isMobileUtil from 'is-mobile';

export const drawWatermark = (
  option: Watermark,
  label: string,
  playerEl: HTMLDivElement,
) => {
  const drawings = {
    default: () => {
      for (let i = 0; i < (option.amount || 1); i += 1) {
        const watermarkEl = document.createElement('span');

        watermarkEl.innerText = label;
        watermarkEl.className = 'watermark';

        const isMobile = +playerEl.offsetWidth < 768 && isMobileUtil();

        if (option.color) {
          watermarkEl.style.color = option.color;
        }
        if (option.fontFamily) {
          watermarkEl.style.fontFamily = option.fontFamily;
        }
        if (option.fontSize) {
          watermarkEl.style.fontSize =
            option.fontSize * (isMobile ? 0.6 : 1) + 'px';
        }
        if (option.angleDeg) {
          watermarkEl.style.transform = `rotate(${option.angleDeg}deg)`;
        }
        playerEl.appendChild(watermarkEl);
        // 기준 폰트 크기를 보관 (리사이즈 시 원복용)
        const appliedFont = parseFloat(
          window.getComputedStyle(watermarkEl).fontSize,
        );
        const baseFont = appliedFont || option.fontSize || 16;
        watermarkEl.dataset.baseFontSize = String(baseFont);
      }

      jwplayer().on('firstFrame', () => {
        if (option.amount > 1) {
          moveWatermark();
        } else {
          // position it in the middle
          const watermarkEl = document.querySelector(
            '.watermark',
          ) as HTMLElement;

          watermarkEl.classList.add('show');
          watermarkEl.style.transform = `translate(-50%, -50%)`;
        }
      });

      jwplayer().on('visualQuality', () => {
        if (option.amount > 1) {
          // 레이아웃 갱신 이후에 위치 계산 (일시정지/재생 전환 시 품질 변경 직후 대응)
          requestAnimationFrame(() => moveWatermark());
        }
      });

      jwplayer().on('levelsChanged', () => {
        if (option.amount > 1) {
          requestAnimationFrame(() => moveWatermark());
        }
      });
    },

    duplicate: () => {
      const dataURL = makeWatermarkDataURL(label, option);
      const watermarkEl = document.createElement('span');

      watermarkEl.className = 'watermark';
      watermarkEl.classList.add('duplicate');

      playerEl.appendChild(watermarkEl);
      // 컨테이너에 반복 배경으로 설정
      watermarkEl.style.backgroundImage = `url(${dataURL})`;
    },

    random: () => {
      drawings.default();
      setInterval(
        moveWatermark,
        option.randomTiming ? option.randomTiming * 1000 : 15000,
      );
    },
  };
  drawings[option.type || 'default']();
};
